<template>
  <div class="recruitment-wrapper">
    <div class="container">
      <!-- 职位标题区 -->
      <div class="job-header">
        <h1 class="job-title">在招职位：营销经理</h1>
        <div class="job-meta">
          <span class="location">📍 北京 &amp; 重庆</span>
        </div>
      </div>

      <!-- 两栏布局：左侧职责要求，右侧公司简介 -->
      <div class="job-content">
        <!-- 左栏 -->
        <div class="left-panel">
          <!-- 岗位职责 -->
          <section class="section">
            <h2 class="section-title">岗位职责</h2>
            <ul class="duty-list">
              <li v-for="(item, index) in duties" :key="index">{{ item }}</li>
            </ul>
          </section>

          <!-- 任职要求 -->
          <section class="section">
            <h2 class="section-title">任职要求</h2>
            <ul class="requirement-list">
              <li v-for="(item, index) in requirements" :key="index">{{ item }}</li>
            </ul>
          </section>

          <!-- 投递方式（单独强调） -->
          <div class="apply-box">
            <p class="apply-label">📬 投递方式</p>
            <a href="mailto:hr@hittop.com.cn" class="apply-email">hr@hittop.com.cn</a>
          </div>
        </div>

        <!-- 右栏：公司简介 -->
        <div class="right-panel">
          <div class="company-card">
            <h2 class="company-name">北京弘运保科技有限公司</h2>
            <div class="company-desc">
              <p>
                公司成立于2020年7月，系弘泰通保投资管理有限公司控股子公司，聚焦商业保理科技领域的核心研发与平台运营，深耕中小企业供应链金融服务赛道，致力于构建垂直领域一体化保理科技生态体系，为中小企业提供全业务链路的数字化科技解决方案与一站式供应链融资全周期服务，破解中小企业融资难、融资贵的行业痛点。
              </p>
            </div>
            <!-- 公司图片展示 -->
            <div class="company-images">
                <img src="@/assets/address.jpg" alt="公司环境" class="company-img w-full h-auto" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// 数据定义
const duties = [
  '开发潜在客户与销售渠道；',
  '熟悉公司产品，开展对外营销推广；',
  '对接客户，专业解答融资相关咨询；',
  '协助客户办理授信申请、签约全流程；',
  '日常客户关系维护与跟进。'
]

const requirements = [
  '统招大专及以上学历；',
  '两年及以上头部物流企业（顺丰 / 京东 / 德邦 / 中通等）招采、运力管理相关经验，或有供应链金融平台从业经历优先；',
  '具备良好商务沟通、客户服务意识与团队协作能力。'
]
</script>

<style scoped>
/* 全局重置与字体 */
.recruitment-wrapper {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background: #f8faff;
  padding: 2rem 1rem;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  max-width: 1280px;
  width: 100%;
  background: #ffffff;
  border-radius: 32px;
  box-shadow: 0 20px 60px rgba(0, 20, 80, 0.08);
  padding: 2.5rem 2rem;
  transition: all 0.3s ease;
}

/* 职位头部 */
.job-header {
  border-bottom: 2px solid #eef2f7;
  padding-bottom: 1.5rem;
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.job-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #0a1e3c;
  margin: 0;
  letter-spacing: -0.02em;
}

.job-meta {
  display: flex;
  gap: 1.5rem;
  font-size: 1rem;
  color: #4a5a72;
  background: #f0f4fe;
  padding: 0.5rem 1.2rem;
  border-radius: 40px;
  flex-wrap: wrap;
}

.job-meta span {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

/* 两栏布局 */
.job-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.5rem;
}

/* 左栏样式 */
.left-panel {
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
}

.section {
  background: #f9fcff;
  border-radius: 20px;
  padding: 1.5rem 1.8rem;
  border: 1px solid #e9eff5;
}

.section-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #0a1e3c;
  margin-top: 0;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 3px solid #3b82f6;
  display: inline-block;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul li {
  padding: 0.5rem 0 0.5rem 1.8rem;
  position: relative;
  line-height: 1.6;
  color: #1e2f4a;
  font-size: 0.98rem;
}

ul li::before {
  content: "▹";
  position: absolute;
  left: 0;
  color: #3b82f6;
  font-weight: bold;
}

/* 投递框 */
.apply-box {
  background: linear-gradient(135deg, #eef6ff, #ffffff);
  border-radius: 16px;
  padding: 1.2rem 1.8rem;
  border: 1px dashed #3b82f6;
  text-align: center;
  margin-top: 0.5rem;
}

.apply-label {
  font-weight: 600;
  color: #0a1e3c;
  margin: 0 0 0.4rem 0;
  font-size: 1rem;
}

.apply-email {
  font-size: 1.4rem;
  font-weight: 600;
  color: #1a4cff;
  text-decoration: none;
  background: white;
  padding: 0.2rem 1.2rem;
  border-radius: 40px;
  box-shadow: 0 2px 8px rgba(26, 76, 255, 0.1);
  transition: 0.2s;
  display: inline-block;
}

.apply-email:hover {
  background: #1a4cff;
  color: white;
  box-shadow: 0 4px 14px rgba(26, 76, 255, 0.3);
}

/* 右栏：公司简介 */
.right-panel {
  display: flex;
  align-items: stretch;
}

.company-card {
  background: linear-gradient(145deg, #ffffff, #f5f9ff);
  border-radius: 24px;
  padding: 2rem 1.8rem;
  width: 100%;
  border: 1px solid #e9eff5;
  box-shadow: 0 8px 24px rgba(0, 20, 80, 0.04);
  position: relative;
  display: flex;
  flex-direction: column;
}

.company-name {
  font-size: 1.6rem;
  font-weight: 700;
  color: #0a1e3c;
  margin: 0 0 0.2rem 0;
}

.company-tagline {
  font-size: 0.95rem;
  color: #3b82f6;
  font-weight: 500;
  margin: 0 0 1rem 0;
  letter-spacing: 0.3px;
}

.company-desc p {
  line-height: 1.7;
  color: #2a3f5c;
  font-size: 0.98rem;
  margin: 0 0 1.5rem 0;
}

.img-placeholder {
  background: #e4ecf7;
  border-radius: 12px;
  padding: 0.8rem 0.2rem;
  text-align: center;
  font-size: 0.85rem;
  color: #4a5a72;
  font-weight: 500;
  transition: 0.2s;
  border: 1px solid #d3dff0;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-placeholder:hover {
  background: #d3dff0;
  transform: translateY(-2px);
}

/* 会员徽章 */
.badge {
  background: #0a1e3c;
  color: white;
  padding: 0.4rem 1rem;
  border-radius: 40px;
  font-size: 0.8rem;
  font-weight: 600;
  align-self: flex-start;
  letter-spacing: 0.5px;
  margin-top: auto;
}

/* 响应式适配 */
@media (max-width: 900px) {
  .job-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .job-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .job-title {
    font-size: 1.8rem;
  }

  .job-meta {
    font-size: 0.9rem;
    padding: 0.3rem 1rem;
  }

  .container {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 1rem;
    border-radius: 20px;
  }

  .job-title {
    font-size: 1.5rem;
  }

  .section {
    padding: 1rem;
  }

  .company-images {
    grid-template-columns: 1fr 1fr;
  }

  .apply-email {
    font-size: 1.1rem;
  }

  .company-name {
    font-size: 1.3rem;
  }
}
</style>